export default __webpack_public_path__ + "static/case-7-3aac09e7aaaff21ec23676bd15afffe9.webp";